import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Article } from '../blog/blog-models/Article';
import { ArticleService } from '../blog/blog-services/article.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    articles: Article[];
    articlesSubscription: Subscription;

    constructor(private articleService: ArticleService) { }

    ngOnInit(): void {
        this.articlesSubscription = this.articleService.articlesSubject.subscribe(
            (data: Article[]) => {
                this.articles = data;
            }
        );
        this.articleService.emitArticles();
    }
}
